import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import MiddlewareLoader from '@/routes/middleware-loader';
import { snackbar } from '@/mixins/snackbar';
import { setupInterceptors } from './services/httpInterceptors';
import Notifications from 'vue-notification';
import velocity from 'velocity-animate';

// console.log('Snackbar', snackbar)

// router setup
import routes from "./routes/routes";

Vue.config.productionTip = false;
// configure router
const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active"
});

router.beforeEach((to,from,next) => {
  return MiddlewareLoader(to,from,next);
});
 
Vue.use(VueRouter);
Vue.use(Notifications, { velocity });

new Vue({
  el: "#app",
  render: h => h(App),
  created() {
		setupInterceptors(store);
	},
  router,
  store,
  vuetify,
  snackbar
});